import { type ReactElement } from 'react';
import { useLocation } from 'react-router';

import TokenExpired from '../Error/TokenExpired';

import NewPassword from './NewPassword';

const UserPasswordUpdate = (): ReactElement => {
  const { search } = useLocation();

  const tokenExpirationTime: number = parseInt(search.split('?t=').pop() ?? '0', 10);

  return tokenExpirationTime > Date.now() ? <NewPassword /> : <TokenExpired />;
};

export default UserPasswordUpdate;
